
import { useEffect } from 'react';
import { useNavigate } from 'react-router';

export default function ModeratorPage() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/submissions', { replace: true });
  }, [navigate]);

  return null;
}
